import React from "react"
import PropTypes from "prop-types"
import { Title, Section } from "@bw/bits"
import { ArrowRight } from "@bw/icons"
import { breakpoints } from "../../../theme"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import { useTranslation } from "react-i18next"
import { Link } from "gatsby"

const Image = styled.div`
  position: relative;
  background-image: url(${props => props.image});
  background-size: cover;
  width: 100%;
  height: 125px;

  @media (min-width: ${breakpoints.medium}px) {
    height: 334px;
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    inset: 0;
    background-color: var(--page-color-rgba);
  }
`

const CartePlusWrapper = styled.div`
  position: relative;
  display: grid;
  gap: 35px;
  z-index: 1;
  width: 100%;
  max-width: 770px;
  background: #fff;
  margin: 0 auto;

  @media (min-width: ${breakpoints.medium}px) {
    gap: 45px;
    grid-template-columns: 1fr 1fr;
    height: 230px;
    padding: 32px 56px 0 0;
    margin-top: -30px;
  }
`

const Carte = styled.div`
  width: 210px;
  margin: -146px 20px 15px auto;

  @media (min-width: ${breakpoints.medium}px) {
    transform: translateX(-30px);
    width: 311px;
    margin: 0 0 48px;
  }
`

const StyledLink = styled(Link)`
  font-weight: bold;
  font-size: 20px;
  line-height: 35px;
  color: var(--font-color);
  text-decoration: none;
  border: none;
  background: none;
  align-items: center;
  display: flex;
  height: fit-content;
  align-self: flex-start;
  > :nth-child(1) {
    transition: transform 0.2s ease-in-out;
    margin-right: 10px;
  }

  &:hover {
    > :nth-child(1) {
      transform: translateX(6px);
    }
  }
  @media (min-width: ${breakpoints.medium}px) {
    align-self: center;
  }
`

const Green = styled.span`
  color: var(--brand-dark-green);
`

const Text = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
`

const Left = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (min-width: ${breakpoints.medium}px) {
    margin-top: -135px;
  }
`

const CartePlus = ({ image, title, text, url }) => {
  const { t } = useTranslation()
  return (
    <Section containerSize="large" margin="60px 0">
      <Image image={image} />
      <CartePlusWrapper>
        <Left>
          <Carte>
            <StaticImage
              className="carte"
              src="../../../images/cartePlus.png"
              alt=""
              width={472}
              height={370}
            />
          </Carte>
          {url && (
            <StyledLink to={url}>
              <ArrowRight className="hover" />
              &nbsp;{t("carteplus.buttonFirstPart")}
              <Green>{t("carteplus.buttonSecondPart")}</Green>
            </StyledLink>
          )}
        </Left>
        <Text>
          <Title size="h4" level="div" title={title} />
          {text}
        </Text>
      </CartePlusWrapper>
    </Section>
  )
}

CartePlus.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
}

export { CartePlus }
